import { ModelRow } from "@mcleod/core";

export class CollectionsSecondaryFilter {
    static readonly FILTER_CURRENT = {
        id: "current",
        caption: "Current",
        filter: (row: ModelRow) => row.getNumber("days_past_due", 0) <= 0
    }

    static readonly FILTER_1_TO_15_DAYS = {
        id: "1To15DaysPastDue",
        caption: "1 - 15 Days Past Due",
        filter: (row: ModelRow) => {
            const daysPastDue = row.getNumber("days_past_due", 0);
            return daysPastDue >= 1 && daysPastDue <= 15;
        }
    }

    static readonly FILTER_16_TO_30_DAYS = {
        id: "16To30DaysPastDue",
        caption: "16 - 30 Days Past Due",
        filter: (row: ModelRow) => {
            const daysPastDue = row.getNumber("days_past_due", 0);
            return daysPastDue >= 16 && daysPastDue <= 30;
        }
    }

    static readonly FILTER_OVER_30_DAYS = {
        id: "over30DaysPastDue",
        caption: "> 30 Days Past Due",
        filter: (row: ModelRow) => {
            return row.getNumber("days_past_due", 0) > 30;
        }
    }

    static readonly FILTER_SHORT_PAYS = {
        id: "shortPays",
        caption: "Short Pays",
        filter: (row: ModelRow) => {
            return row.getBoolean("short_pay", false);
        }
    }
}
